import { render, staticRenderFns } from "./LightContent.vue?vue&type=template&id=701ea416&scoped=true"
import script from "./LightContent.vue?vue&type=script&lang=js"
export * from "./LightContent.vue?vue&type=script&lang=js"
import style0 from "./LightContent.vue?vue&type=style&index=0&id=701ea416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701ea416",
  null
  
)

export default component.exports